/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ManagerControllerDtoManagerInfoUpdateRequest model module.
 * @module model/ManagerControllerDtoManagerInfoUpdateRequest
 * @version 1.0
 */
class ManagerControllerDtoManagerInfoUpdateRequest {
    /**
     * Constructs a new <code>ManagerControllerDtoManagerInfoUpdateRequest</code>.
     * @alias module:model/ManagerControllerDtoManagerInfoUpdateRequest
     * @param managerNo {Number} 
     * @param name {String} 
     * @param email {String} 
     * @param groupNo {Number} 
     * @param departmentNo {Number} 
     * @param enabled {Boolean} 
     */
    constructor(managerNo, name, email, groupNo, departmentNo, enabled) { 
        
        ManagerControllerDtoManagerInfoUpdateRequest.initialize(this, managerNo, name, email, groupNo, departmentNo, enabled);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, managerNo, name, email, groupNo, departmentNo, enabled) { 
        obj['managerNo'] = managerNo;
        obj['name'] = name;
        obj['email'] = email;
        obj['groupNo'] = groupNo;
        obj['departmentNo'] = departmentNo;
        obj['enabled'] = enabled;
    }

    /**
     * Constructs a <code>ManagerControllerDtoManagerInfoUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ManagerControllerDtoManagerInfoUpdateRequest} obj Optional instance to populate.
     * @return {module:model/ManagerControllerDtoManagerInfoUpdateRequest} The populated <code>ManagerControllerDtoManagerInfoUpdateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ManagerControllerDtoManagerInfoUpdateRequest();

            if (data.hasOwnProperty('managerNo')) {
                obj['managerNo'] = ApiClient.convertToType(data['managerNo'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('groupNo')) {
                obj['groupNo'] = ApiClient.convertToType(data['groupNo'], 'Number');
            }
            if (data.hasOwnProperty('departmentNo')) {
                obj['departmentNo'] = ApiClient.convertToType(data['departmentNo'], 'Number');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ManagerControllerDtoManagerInfoUpdateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ManagerControllerDtoManagerInfoUpdateRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of ManagerControllerDtoManagerInfoUpdateRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}

ManagerControllerDtoManagerInfoUpdateRequest.RequiredProperties = ["managerNo", "name", "email", "groupNo", "departmentNo", "enabled"];

/**
 * @member {Number} managerNo
 */
ManagerControllerDtoManagerInfoUpdateRequest.prototype['managerNo'] = undefined;

/**
 * @member {String} name
 */
ManagerControllerDtoManagerInfoUpdateRequest.prototype['name'] = undefined;

/**
 * @member {String} email
 */
ManagerControllerDtoManagerInfoUpdateRequest.prototype['email'] = undefined;

/**
 * @member {Number} groupNo
 */
ManagerControllerDtoManagerInfoUpdateRequest.prototype['groupNo'] = undefined;

/**
 * @member {Number} departmentNo
 */
ManagerControllerDtoManagerInfoUpdateRequest.prototype['departmentNo'] = undefined;

/**
 * @member {Boolean} enabled
 */
ManagerControllerDtoManagerInfoUpdateRequest.prototype['enabled'] = undefined;






export default ManagerControllerDtoManagerInfoUpdateRequest;

